import React, { FunctionComponent } from 'react'

import { useRoutes } from 'react-router-dom'

import { getRoleFromLocalStorage } from '@/helpers/storage-utils'
import { getRoutes } from '@/routes'

const App: FunctionComponent = () => {
  const role = getRoleFromLocalStorage()
  const routes = getRoutes(role)
  const router = useRoutes(routes)

  return <>{router}</>
}

export default App
